import { colors, weights } from '@components/theme/styles/index';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { rem } from 'polished';

export const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    borderRadius: rem(16),
    minWidth: rem(400),
    maxWidth: rem(600),
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
  },
});

export const StyledDialogTitle = styled(DialogTitle)({
  backgroundColor: colors.primary,
  color: colors.primaryDark3,
  padding: `${rem(16)} ${rem(24)}`,
  display: 'flex',
  alignItems: 'center',
  gap: rem(16),
  marginBottom: rem(16),
  borderTopLeftRadius: rem(16),
  borderTopRightRadius: rem(16),
  '& .MuiTypography-root': {
    fontWeight: weights.semiBold,
  },
});

export const StyledDialogContent = styled(DialogContent)({
  padding: rem(24),
});

export const StyledDialogActions = styled(DialogActions)({
  padding: `${rem(16)} ${rem(24)}`,
  gap: rem(8),
});

export const Logo = styled('img')({
  width: rem(32),
  height: rem(28),
});

export const FileInviteButton = styled(Button)({
  backgroundColor: colors.primary,
  color: colors.primaryDark3,
  fontWeight: weights.medium,
  '&:hover': {
    backgroundColor: colors.primaryDark1,
  },
  '&:disabled': {
    backgroundColor: colors.primaryLight2,
    color: colors.primaryDark2,
  },
});

export const ErrorDisplayBox = styled('div')({
  marginTop: rem(16),
  marginBottom: rem(8),
  padding: rem(16),
  backgroundColor: colors.primaryLight4,
  borderRadius: rem(8),
  border: `1px solid ${colors.primaryLight2}`,
});
